import { ActivePhonesData } from "@sms/shared/active-phones/active-phones.interface";
import { PayloadAction, createAction, EmptyAction } from "typesafe-actions";

export const setActivePhonesAction: (
  activePhones: ActivePhonesData[]
) => PayloadAction<"activePhones/setActivePhonesAction", ActivePhonesData[]> = createAction(
  "activePhones/setActivePhonesAction"
)<ActivePhonesData[]>();

export const getActivePhonesAction: () => EmptyAction<"activePhones/getActivePhonesAction"> = createAction(
  "activePhones/getActivePhonesAction"
)();
